import React, { Component} from 'react';

import library from './avatars.library';

class AvatarImg extends Component {
  state = {
    hasError: false
  };

  get config() {
    const { user: { id } } = this.props;
    const shapes = library[this.sizeName];
    const i = parseInt(id, 16);
    const color = i % library.colors.length;
    const shape = i % shapes.length;

    return { color, shape };
  }

  get side() {
    const { small } = this.props;
    const SMALL_SIZE = 35;
    const LARGE_SIZE = 50;

    return small ? SMALL_SIZE : LARGE_SIZE;
  }

  get sizeName() {
    const { small } = this.props;
    return small ? 'small' : 'large';
  }

  get svgAvatar() {
    const { color, shape } = this.config;
    const d = library[this.sizeName][shape]
    const fill = library.colors[color];
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={this.side}
        height={this.side}
        viewBox={`0 0 ${this.side} ${this.side}`}
      >
        <path d={d} fill={fill} fillRule="evenodd" />
      </svg>
    );
  }

  onError = () => {
    this.setState({ hasError: true });
  }

  render() {
    const { user } = this.props;
    const { hasError } = this.state;

    if (!user.avatarUrl || hasError) {
      return (
        <span className="user-avatar">
          {this.svgAvatar}
        </span>
      )
    };

    return (
      <span className='user-avatar'>
        <img
          alt='Avatar'
          width={this.side}
          height={this.side}
          className='rounded-circle'
          src={user.avatarUrl}
          onError={this.onError}
        />
      </span>
    );
  }
}

AvatarImg.defaultProps = {
  small: false,
};


export default AvatarImg;



// WEBPACK FOOTER //
// ./src/components/avatar-img.js